
var environment = {
    api_url : "https://api.careerkart.in",
};

export default environment;